import { Injectable } from '@angular/core';
import {CrudService} from "./crud.service";
import {Driver} from "../models/driver";
import {HttpClient} from "@angular/common/http";
import {Review} from "../models/review";
import {TableQueryParams} from "../models/table-query-params";
import {PagedResponse} from "../models/paged-response";
import {TableUtils} from "../utils/table.utils";

@Injectable({
  providedIn: 'root'
})
export class ReviewService extends CrudService<Review> {
    constructor(http: HttpClient) {
        super(http, 'reviews');
    }

    getAllExtra(params: TableQueryParams, byUser, forUser, bookingId): Promise<PagedResponse<Review>> {
        const queryParams = TableUtils.prepareForApiParams(params);
        if(byUser) queryParams.byUser = byUser;
        if(forUser) queryParams.forUser = forUser;
        if(bookingId) queryParams.booking = bookingId;
        return this.http
            .get<PagedResponse<Review>>(this.endpoint, {params: queryParams})
            .toPromise();
    }


    async resetDriverReview(id: string) {
        await this.http.post<any>(`drivers/${id}/resetReview`, {}).toPromise();
        this.dataChangedSubject.next(true);
    }
}
